import { useEffect } from 'react';
import isEmpty from 'lodash/isEmpty';
import { useModal } from 'core/modules/Modal/ModalProvider';
import { useGetBonusOffers } from 'core/modules/BonusOffers/hooks';
import { parseBonusButton } from 'core/modules/BonusButton/utils/parseBonusButton';
import { useCheckIsEligibleToFetchData } from './useCheckIsEligibleToFetchData';

export const useHandleBonusButtonModal = () => {
  const { openModal } = useModal();
  const isEligibleToFetchData = useCheckIsEligibleToFetchData();
  const { bonusButtonModal } = useGetBonusOffers(isEligibleToFetchData);

  useEffect(() => {
    const { isQualified, isEnded } = parseBonusButton(bonusButtonModal);
    if (isEligibleToFetchData && !isEmpty(bonusButtonModal) && !isQualified && !isEnded) {
      openModal({ name: 'mt_bonusButton' });
    }
  }, [bonusButtonModal, isEligibleToFetchData]);
};
